import DealerRoadmap from "../../components/serviceAndSupport/dealerRoadmap";
import Faqs from "../../components/serviceAndSupport/faq";
import Requirements from "../../components/serviceAndSupport/requirements";
import ServiceAndSupportBanner from "../../components/serviceAndSupport/serviceAndSupportBanner";
import ServiceBuildFleet from "../../components/serviceAndSupport/servicebuildFleet";
import WhyTuatara from "../../components/serviceAndSupport/whyTuatara";

const ServiceAndSupport = () => {
  return (
    <>
      <ServiceAndSupportBanner />
      <div className="bg-[#fff] lg:pt-[107px] md:pt-[80px] sm:pt-[60px] pt-[40px]">
        <WhyTuatara />
      </div>
      <div className="bg-[#7ABF5B]">
        <DealerRoadmap />
      </div>

      <div className="bg-[#fff] lg:pt-[107px] md:pt-[80px] sm:pt-[60px] pt-[40px]">
        <Requirements />
      </div>
      <div className="bg-[#F2F2F2]">
        <ServiceBuildFleet />
      </div>
      <div className="bg-[#fff] lg:py-[137px] md:py-[60px] sm:py-[40px] py-[20px]">
        <Faqs />
      </div>
    </>
  );
};
export default ServiceAndSupport;
